import { FileInfo } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'

export const baseParams = {
  method: 'GET',
  mode: 'cors',
  headers: {
    'Accept-Language': 'ES',
    'Content-Type': 'application/json',
    Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
  },
}

//DON'T TOUCH OR LOGIC MAY BREAK
export const EXTRA_DIMENTIONS_DISTANCE = 0 as const
export const BASE_ANGLE_SNAP_DEGREES = 10 as const
export const variation = BASE_ANGLE_SNAP_DEGREES / (Math.PI * 180)
export const MORPHS_DICTIONARY_EN_TO_ES = {
  thickness: 'Fondo',
  height: 'Alto',
  width: 'Ancho',
}
export const MORPHS_DICTIONARY_ES_TO_EN = {
  Fondo: 'thickness',
  Alto: 'height',
  Ancho: 'width',
}
export const ninetyDeg = Math.PI / 2
export const max0 = variation
export const min0 = -variation
export const max90 = ninetyDeg + variation
export const min90 = ninetyDeg - variation
export const oneEightyDeg = Math.PI
export const max180 = -oneEightyDeg + variation
export const min180 = oneEightyDeg - variation
export const twoSeventyDeg = -Math.PI / 2
export const max270 = twoSeventyDeg - variation
export const min270 = twoSeventyDeg + variation
export const pi = oneEightyDeg
export const halfPi = ninetyDeg
export const piFourths = oneEightyDeg / 4
export const piEighths = oneEightyDeg / 8
export const pipi = 2 * pi //This one is fun sorry but can't write 2pi as const
export const fourtyFiveDeg = Math.PI / 4
export const oneThirtyFiveDeg = fourtyFiveDeg + ninetyDeg
export const twoTwoFiveDeg = oneEightyDeg + fourtyFiveDeg
export const EPSILON = 1e-6 as const

//Please keep touching if needed below here.
const CAMERA_X = -2000
const CAMERA_Y = 2500
const CAMERA_Z = 10
export const BASE_CAMERA_OBB_SIZE = toVector3([50, 50, 3000])
export const baseCamera3DData = {
  position: toVector3([CAMERA_X, CAMERA_Y, CAMERA_Z]),
  // rotation: new Matrix3(
  //   -0.018978153267001304,
  //   4.85722573273506e-16,
  //   0.9998198986310356,
  //   0.1679044926387397,
  //   0.9857981151338453,
  //   0.00318709119500285,
  //   -0.9856205715437871,
  //   0.16793473791493485,
  //   -0.018708627719331197,
  // ),
  zoom: 1,
}
export const baseCamera2DData = { position: toVector3([0, 9900, 0]), zoom: 0.15 }
export const lastView = { position: toVector3([0, 0, 0]), target: toVector3([0, 0, 0]) }
export const baseLayers = [
  {
    layerID: 0,
    name: 'layer-0',
    order: 0,
    opacity: 1,
    altitude: 0,
    items: new Set<string>(),
    areas: new Set<string>(),
    selected: new Set<string>(),
    deltas: new Map<
      string,
      Array<{ targetId: string; deltaX: number; deltaY: number; deltaZ: number }>
    >(),
  },
]
export const emptyClientInfo = {
  nombreProyecto: '',
  descripcion: '',
  nombre: '',
  apellidos: '',
  direccion: '',
  codPostal: '',
  poblacion: '',
  email: '',
  pais: '',
  movil: '',
  numProyectoTpc: '',
  idDisenos: 0,
  idVersiones: 0,
  idImpuestos: 0,
  disenadorActual: null,
  disenadorOriginal: null,
}

export const emptyFileInfo: FileInfo = {
  fileName: '',
  reference: '',
  fileDescription: '',
  longDescription: '',
  url: '',
  originalExtension: 'gltf',
  glbBlob: new Blob(),
  newExtension: 'glb',
  width: 0,
  height: 0,
  depth: 0,
  placementHeight: 0,
  unit: 'cm',
  tipoNormalizado: 'otros',
  glbUrl: '',
  jpgUrl: '',
  price: 0,
  folder: '',
  pngBlob: new Blob(),
  glbBase64: '',
}

export const baseTextos = {
  idioma: {
    id: 1,
    codigo: 'ES',
    nombreCultura: 'ES',
    idioma: 'Español',
  },
  textos: {
    MSG_1: '¿Seguro que quieres hacer eso?',
    MSG_2: 'He encontrado {{numero}} diseños',
    MSG_4: 'Ancho',
    MSG_5: 'Fondo',
    MSG_6: 'Alto',
    MSG_7: 'Altura De Colocación',
    MSG_8: 'CAMBIAR RENDER',
    MSG_9: 'Nuevo Diseño',
    MSG_10: 'Diseño Existente',
    MSG_11: 'Localizar tienda',
    MSG_12: 'Contacto',
    MSG_13: 'Compartir proyecto',
    MSG_14: 'Paredes',
    MSG_15: 'Propiedades',
    MSG_16: 'Sí',
    MSG_17: 'No',
    MSG_18: 'Ángulo',
    MSG_19: 'Textura',
    MSG_20: 'Textura 1',
    MSG_21: 'Textura 2',
    MSG_22: 'Enlace 1',
    MSG_23: 'Enlace 2',
    MSG_24: 'Unlink 1',
    MSG_25: 'Opciones',
    MSG_26: 'Buscar...',
    MSG_27: 'Búsqueda Avanzada',
    MSG_28: 'Acabado',
    MSG_29: 'Universal Texturas',
    MSG_30: 'Colores Lisos',
    MSG_31: 'RAL',
    MSG_32: 'Pantone',
    MSG_33: 'Textura',
    MSG_34: 'Estilo',
    MSG_35: 'Ok',
    MSG_36: 'Cancelar',
    MSG_37: 'Acabados',
    MSG_38: 'Iniciar Sesión',
    MSG_39: 'Crear cuenta',
    MSG_40: 'Correo',
    MSG_41: 'Contraseña',
    MSG_42: '¿Olvidaste tu contraseña?',
    MSG_43: 'Recuérdame',
    MSG_44: 'Registrate',
    MSG_45: 'Nombre',
    MSG_46: 'Apellidos',
    MSG_47: 'Dirección',
    MSG_48: 'Código postal',
    MSG_49: 'Teléfono',
    MSG_50: 'Confirmar contraseña',
    MSG_51: 'He leido y acepto la',
    MSG_52: 'Política de Privacidad',
    MSG_53: 'Condiciones de uso ',
    MSG_54: 'confirme los términos',
    MSG_55: '¿Ya tienes cuenta? Inicia sesion',
    MSG_56: 'y las',
    MSG_57: 'Menu de Preferencias',
    MSG_58: 'Para construir tu estancia, introduce las medidas de tu habitación',
    MSG_59: 'Medidas',
    MSG_60: 'Grueso',
    MSG_61: 'Empresa',
    MSG_62: 'CIF',
    MSG_63: 'Pais',
    MSG_64: 'Ciudad',
    MSG_65: 'Idioma',
    MSG_66: 'Modificar mis datos',
    MSG_67: 'Gestionar Proyectos',
    MSG_68: 'Cerrar sesión',
    MSG_69: 'Ordenar por',
    MSG_70: 'Email',
    MSG_71: 'Fecha de inicio',
    MSG_72: 'Fecha de última modificación',
    MSG_73: 'Estado',
    MSG_74: 'Nombre proyecto',
    MSG_75: 'Documentos creados',
    MSG_76: 'Descripción',
    MSG_77: '¿Quieres borrar las paredes existentes?',
    MSG_78: 'Nombre proyecto',
    MSG_79: 'Datos del cliente',
    MSG_80: 'C.P.',
    MSG_81: 'Móvil',
    MSG_82: 'Guardar',
    MSG_83: 'Buscar',
    MSG_84: 'Dirección',
    MSG_85: 'Presupuesto',
    MSG_86: 'Pendiente',
    MSG_87: 'Fecha inicio:',
    MSG_88: 'Factura',
    MSG_89: 'Apertura de puerta',
    MSG_90: 'Otros parámetros',
    MSG_91: 'Interior cajones',
    MSG_92: 'Mano',
    MSG_93: 'Acabado',
    MSG_94: 'Frontal',
    MSG_95: 'Trasera',
    MSG_96: 'Precio',
    MSG_97: 'Ventana',
    MSG_98: 'Pared',
    MSG_99: 'Pared de ladrillos o pintada',
    MSG_100: 'Puerta de madera',
    MSG_101: 'Modificar datos',
    MSG_102: 'Precio total:',
    MSG_103: 'Puerta',
    MSG_104: 'Puerta doble',
    MSG_105: 'Puerta de hierro',
    MSG_106: 'Ventana de dos hojas',
    MSG_107: 'Ventana una hoja',
    MSG_108: 'Ventana fija una hoja',
    MSG_109: 'Natural',
    MSG_110: 'Alsacia',
    MSG_111: 'Antracita mate',
    MSG_112: 'Black Velvet',
    MSG_113: 'Blanco Brillo',
    MSG_114: 'Blue Flog',
    MSG_115: 'Green Forest',
    MSG_116: 'Macchiato',
    MSG_117: 'Night Blue',
    MSG_118: 'Pino Bahia',
    MSG_119: 'Roble Africa',
    MSG_120: 'White Cotton',
    MSG_121: 'Real',
    MSG_122: 'Pure',
    MSG_123: 'Intense',
    MSG_124: 'Mármol',
    MSG_125: 'Bohemian blue',
    MSG_126: 'Green mosaic',
    MSG_127: 'Green',
    MSG_128: 'RAL 15010',
    MSG_129: 'RAL 19016',
    MSG_130: 'Hidráulico',
    MSG_131: 'Parquet',
    MSG_132: 'Introduzca empresa',
    MSG_133: 'Introduzca CIF',
    MSG_134: 'Introduzca direccion',
    MSG_135: 'Introduzca ciudad',
    MSG_136: 'Introduzca codigo postal',
    MSG_137: 'Introduzca pais',
    MSG_138: 'Guardar proyecto',
    MSG_139: 'Español',
    MSG_140: 'Portugues',
    MSG_141: 'Francés',
    MSG_142: 'Italiano',
    MSG_143: 'Ingles',
    MSG_144: 'Aleman',
    MSG_145: 'Holandés',
    MSG_146: 'Lavabo',
    MSG_147: 'Ninguno',
    MSG_148: 'Habitación genérica',
    MSG_149: 'Búsqueda avanzada',
    MSG_150: 'Intensidad',
    MSG_151: 'Temperatura color',
    MSG_152: 'Penumbra',
    MSG_153: 'Potencia',
    MSG_154: 'Mostrar sombras',
    MSG_155: 'Iluminación',
    MSG_156: 'Luz de ambiente',
    MSG_157: 'Luz de foco',
    MSG_158: 'Luz direccional',
    MSG_159: 'Punto de luz',
    MSG_160: 'Distancia',
    MSG_161: 'Color',
    MSG_181: 'Texturas Universales',
    MSG_182: 'Area',
    MSG_222: 'Zona Objeto',
    MSG_223: 'Acabado Zona',
    MSG_380: 'Debes guardar el proyecto antes de ver el estado de elementos',
    MSG_470: 'Modo rendimiento desactivado',
    MSG_471: 'Modo rendimiento activado',
    MSG_500: 'Desactivar optimización',
    MSG_501: 'Activar optimización',
    MSG_502: 'Optimización activada: Sin sombras, sin antialias, DPR=1',
    MSG_503: 'Optimización desactivada: Sombras y antialias restaurados',
    MSG_510: 'Abrir estancia',
    MSG_511: 'Debe guardar el proyecto antes de enviar el correo.',
    MSG_512: 'Cambiar vista',
    MSG_513: 'Editar imagen',
    MSG_514: 'Postprocesado',
    MSG_515: 'Descargar imagen',
    /* Inspector de cocina (MSG_610–638). Cambiar números en utils/kitchenInspector/messages.ts si el backend usa otros. Pruebas y ejemplos*/
    MSG_610: 'Inspector de cocina',
    MSG_611: 'No hay errores en el diseño actual.',
    MSG_612: 'Sin incidencias',
    MSG_613: 'Cerrar',
    MSG_614: '{{count}} errores detectados',
    MSG_615: 'Debe iniciar sesión',
    MSG_616: 'Debe hacer login para acceder a todas las funcionalidades del diseñador.',
    MSG_617: 'Proyecto sin guardar',
    MSG_618: 'Falta guardar el proyecto. Guarde el diseño antes de continuar.',
    MSG_619: 'Falta un frigorífico en tu cocina',
    MSG_620: 'Por norma, la cocina debe incluir un frigorífico. Añádelo desde el catálogo.',
    MSG_621: 'Falta un fregadero en tu cocina',
    MSG_622: 'Por norma, la cocina debe incluir un fregadero. Añádelo desde el catálogo.',
    MSG_623: 'Falta una placa en tu cocina',
    MSG_624: 'Por norma, la cocina debe incluir una placa de cocción. Añádela desde el catálogo.',
    MSG_625: 'Falta un horno en tu cocina',
    MSG_626: 'Por norma, la cocina debe incluir un horno. Añádelo desde el catálogo.',
    MSG_627: 'Fregadero junto a la placa',
    MSG_628:
      'No es posible colocar el fregadero tan cerca ({{distance}}). Entre el fregadero y la placa debe existir una separación.',
    MSG_629: 'Horno cerca del fregadero',
    MSG_630:
      'El horno está a {{distance}} del fregadero. Conviene separarlos por riesgo eléctrico y salpicaduras.',
    MSG_631: 'Muebles muy juntos',
    MSG_632: 'Dos unidades se solapan o están demasiado pegadas. Revisa la distribución.',
    MSG_633: 'Lavavajillas con poco espacio',
    MSG_634:
      'Hay un obstáculo a {{distance}} del lavavajillas. Deja espacio libre para abrir la puerta.',
    MSG_635: 'Puerta obstruida',
    MSG_636:
      'Un mueble en la misma pared está tapando la puerta. Desplázalo para no bloquear la apertura.',
    MSG_637: 'Ventana obstruida',
    MSG_638:
      'Un mueble en la misma pared está tapando la ventana. Desplázalo para no bloquearla.',
  } satisfies Record<`MSG_${number}`, string>,
}
